import { ACTION } from './actions';

const locationArticlesReducer = (
  state = {
    byLocationId: {},
  },
  action,
) => {
  switch (action.type) {
    case ACTION.LOCATION_ARTICLES_REQUEST:
      return {
        ...state,
        byLocationId: {
          ...state.byLocationId,
          [action.payload.locationId]: {
            ...state.byLocationId[action.payload.locationId],
            isFetching: true,
          },
        },
      };
    case ACTION.LOCATION_ARTICLES_SUCCESS:
      return {
        ...state,
        byLocationId: {
          ...state.byLocationId,
          [action.payload.locationId]: {
            ...state.byLocationId[action.payload.locationId],
            articles:
              action.payload.offset === 0
                ? action.payload.articles
                : [
                    ...state.byLocationId[action.payload.locationId].articles,
                    ...action.payload.articles,
                  ],
            nextOffset: action.payload.nextOffset,
            isFetching: false,
          },
        },
      };
    case ACTION.LOCATION_ARTICLES_FAILURE:
      return {
        ...state,
        byLocationId: {
          ...state.byLocationId,
          [action.payload.locationId]: {
            ...state.byLocationId[action.payload.locationId],
            articles: [],
            nextOffset: null,
            isFetching: false,
          },
        },
      };
    default:
      return state;
  }
};

export { locationArticlesReducer };



// WEBPACK FOOTER //
// ./src/app/container/locationDetail/reducers.js